import React from 'react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Star, Target, Medal, Trophy } from 'lucide-react';

interface Achievement {
  id: string;
  title: string;
  description: string;
  icon: React.ReactNode;
  type: 'milestone' | 'assessment' | 'learning' | 'career';
  isUnlocked: boolean;
  date?: string;
}

export function AchievementsPanel() {
  const achievements: Achievement[] = [
    {
      id: '1',
      title: 'First Steps',
      description: 'Complete the onboarding process',
      icon: <Star className="w-5 h-5 text-yellow-500" />,
      type: 'milestone',
      isUnlocked: true,
      date: '2024-03-15'
    },
    {
      id: '2',
      title: 'Skills Pioneer',
      description: 'Complete your first skills assessment',
      icon: <Target className="w-5 h-5 text-blue-500" />,
      type: 'assessment',
      isUnlocked: false
    },
    {
      id: '3',
      title: 'Path Finder',
      description: 'Complete your first learning path',
      icon: <Medal className="w-5 h-5 text-purple-500" />,
      type: 'learning',
      isUnlocked: false
    }
  ];

  const unlockedCount = achievements.filter(a => a.isUnlocked).length;

  return (
    <Card className="p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-semibold">Achievements</h2>
        <Badge variant="outline">
          {unlockedCount}/{achievements.length}
        </Badge>
      </div>
      <div className="space-y-4">
        {achievements.map((achievement) => (
          <div 
            key={achievement.id}
            className={`p-4 rounded-lg ${
              achievement.isUnlocked ? 'bg-slate-800/50' : 'bg-slate-800/30'
            }`}
          >
            <div className="flex items-start gap-3">
              <div className="mt-1">{achievement.icon}</div>
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <h3 className="font-medium">{achievement.title}</h3>
                  {achievement.date && (
                    <span className="text-xs text-slate-400">
                      {new Date(achievement.date).toLocaleDateString()}
                    </span>
                  )}
                </div>
                <p className="text-sm text-slate-400 mt-1">
                  {achievement.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}